export interface ResponseCamerasState {
  branchId:   number;
  cameras:    Cameras[];
  lastUpdate: Date;
  status:     string;
}

export interface Cameras {
  cameraName:      string;
  cameraId:        number;
  status:          Status;
  ipAddress:       string;
  lastSync:        Date;
  timeStatus:      TimeStatus;
  cameraTimeUTC:   Date;
  cameraTimeLocal: Date;
  ultimoConteo:    Date;
  sinConteo:       string;
}

export enum Status {
  offline = "offline",
  online = "online",
}

export enum TimeStatus {
  ok = "ok",
  atrasada = "atrasada",
  adelantada = "adelantada",
  desincronizadaPasado = "desincronizada pasado",
  desincronizadaFuturo = "desincronizada futuro",
  desconocido = "desconocido"
}
